export const dabFilmsConstants = {
	DABFilmsSaveRequest: "DABFILMS_SAVE_STARTED",
	DABFilmsSaveSuccess: "DABFILMS_SAVE_COMPLETED",
	DABFilmsSaveFailure: "DABFILMS_SAVE_FAILED",

	DABFilmsGetByfilterRequest: "DABFILMS_GET_BYFILTER_STARTED",
	DABFilmsGetByfilterSuccess: "DABFILMS_GET_BYFILTER_COMPLETED",
	DABFilmsGetByfilterFailure: "DABFILMS_GET_BYFILTER_FAILED",

	DABFilmsDetailRequest: "DABFILMS_GET_DETAIL_STARTED",
	DABFilmsDetailSuccess: "DABFILMS_GET_DETAIL_COMPLETED",
	DABFilmsDetailFailure: "DABFILMS_GET_DETAIL_FAILED",

	DABFilmsDeleteRequest: "DABFILMS_VIDEO_DELETE_STARTED",
	DABFilmsDeleteSuccess: "DABFILMS_VIDEO_DELETE_COMPLETED",
	DABFilmsDeleteFailure: "DABFILMS_VIDEO_DELETE_FAILED",

	DABFilmsVideoStatusUpdateRequest: "DABFILMS_VIDEO_STATUS_UPDATE_STARTED",
	DABFilmsVideoStatusUpdateSuccess: "DABFILMS_VIDEO_STATUS_UPDATE_COMPLETED",
	DABFilmsVideoStatusUpdateFailure: "DABFILMS_VIDEO_STATUS_UPDATE_FAILED",
};
